export default "__VITE_ASSET__e33b4b06__"